import styled from "styled-components";

export const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 736px;
  padding-left: 16px;
  padding-right: 16px;
`;
